export default "//yastatic.net/s3/distribution/pythia/frontend/_/e2164196bf2e23b9488d77e3d05cb83d.png";